import React, { useState } from "react";
import "../css/RegisterPage.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NavLink, useNavigate } from "react-router-dom";
import {
	doCreateUserWithEmailAndPassword,
	doSendEmailVerification,
} from "../config/auth";
import fire from "../config/fire";
import { getDatabase, ref, set, onValue } from "firebase/database";
import { setUserInfo } from "../localStorage";
import LoaderComponent from "../component/LoaderComponent";

const RegisterPage = () => {
	const navigate = useNavigate();
	const [loader, setLoader] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [formData, setFormData] = useState({
		fName: "",
		lName: "",
		email: "",
		mobileNumber: "",
		password: "",
		confirmPassword: "",
	});

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		const { fName, lname, email, mobileNumber, password, confirmPassword } =
			formData;

		if (!/^\d{10}$/.test(mobileNumber)) {
			setError("Please enter a valid 10-digit mobile number");
			return;
		}

		if (password !== confirmPassword) {
			setError("Passwords do not match");
			return;
		}

		try {
			setLoading(true);
			setLoader(true);
			const userCredential = await doCreateUserWithEmailAndPassword(
				email,
				password,
			);
			await doSendEmailVerification();
			const uid = userCredential.user.uid;
			// Save user data in Realtime DB
			const db = getDatabase();
			const userData = {
				fName: formData.fName,
				lName: formData.lName,
				email: formData.email,
				mobile: formData.mobileNumber,
				userId: uid,
				creationDate: Date(),
				adminId: 'null'
			};
			await set(ref(db, "users/" + uid), {
				...userData,
			});
			setUserInfo(userData);
			toast.success("Registration successful! Please verify your email.");
			navigate("/");
		} catch (err) {
			setError(err.message);
			setLoader(false);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="register-wrapper">
			{loader ? <LoaderComponent /> : ""}
			<div className="register-card">
				<h2 className="register-title">Create Account 🚀</h2>
				<p className="register-subtitle pt-4">
					Join us by filling the details below
				</p>

				{error && <p className="error-text">{error}</p>}

				<form className="register-form" onSubmit={handleSubmit}>
					<div className="input-group">
						<input
							type="text"
							name="fName"
							value={formData.fname}
							onChange={handleChange}
							required
						/>
						<label>First Name</label>
					</div>

					<div className="input-group">
						<input
							type="text"
							name="lName"
							value={formData.lName}
							onChange={handleChange}
							required
						/>
						<label>Last Name</label>
					</div>

					<div className="input-group">
						<input
							type="email"
							name="email"
							value={formData.email}
							onChange={handleChange}
							required
						/>
						<label>Email Address</label>
					</div>

					<div className="input-group">
						<input
							type="tel"
							name="mobileNumber"
							value={formData.mobileNumber}
							onChange={handleChange}
							maxLength="10"
							required
						/>
						<label>Mobile Number</label>
					</div>

					<div className="input-group">
						<input
							type={showPassword ? "text" : "password"}
							name="password"
							value={formData.password}
							onChange={handleChange}
							required
						/>
						<label>Password</label>
						<span
								className="password-toggle"
								onClick={() => setShowPassword(!showPassword)}
							>
								<i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
							</span>
					</div>

					<div className="input-group">
						<input
							type={showPassword ? "text" : "password"}
							name="confirmPassword"
							value={formData.confirmPassword}
							onChange={handleChange}
							required
						/>
						<label>Confirm Password</label>
						<span
								className="password-toggle"
								onClick={() => setShowPassword(!showPassword)}
							>
								<i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
							</span>
					</div>

					<button
						type="submit"
						className="register-btn"
						disabled={loading}
					>
						{loading ? "Registering..." : "Register"}
					</button>

					<p className="login-text">
						Already have an account ?
						<NavLink to="/login" className="login-link pl-2">
							Login
						</NavLink>
					</p>
				</form>
			</div>
		</div>
	);
};

export default RegisterPage;
